import { Button, Card, Image } from "react-bootstrap";
import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import "./Dashboard.css";
import { useEffect } from "react";
import useAuth from "../hooks/useAuth";

export default function Dashboard() {
  const auth = useAuth();
  useEffect(() => {
    auth
      .fetch("/api/me")
      .then((res) => res.json())
      .then(console.log);
  }, [auth]);

  return (
    <Fragment>
      <NavLink to="/EditProfile">
        <Button className="edit-button" variant="primary">
          Edit Profile
        </Button>
      </NavLink>

      <div id="profilePicDiv">
        <Image className="profile-pic" src="profile.png" roundedCircle />
      </div>

      <Card className="about-me-dashboard">
        <Card.Title className="about-title">
          <h4>About Me</h4>
        </Card.Title>
        <Card.Body>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Duis aute irure dolor in
          reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
          pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
          culpa qui officia deserunt mollit anim id est laborum.
        </Card.Body>
      </Card>
    </Fragment>
  );
}
